import {
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { getAccessToken } from "../config/token";
import { apiUrl } from "../config/dataProvider";

const prepareHeaders = (headers, api) => {
  const token = getAccessToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  headers.set("Content-Type", "application/json");
  headers.set("Accept", "application/json");
  return headers;
};

const baseQuery = fetchBaseQuery({
  baseUrl: apiUrl,
  prepareHeaders: prepareHeaders,
});

export const api = createApi({
  baseQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});
